module.exports = __webpack_public_path__ + "img/l2.a2a328e6.jpg";